<template lang="pug">
  BSteps#challenge-builder-steps(
    :value="activeStep-1"
    :animated="false"
    :has-navigation="false"
  )
    BStepItem(
      v-for="step in steps"
      :key="step.label"
      :label="step.label"
      :icon="isCompletedStep(step.number) ? 'check-bold' : step.icon"
      :clickable="false"
    )
    slot
</template>

<script>
// allowing 5 so the last step can be completed
const VALID_STEPS = [1, 2, 3, 4, 5];

export default {
  name: "ChallengeBuilderSteps",

  props: {
    activeStep: {
      type: Number,
      default: 1,
      validator(step) {
        return VALID_STEPS.indexOf(step) !== -1;
      }
    }
  },

  data() {
    return {
      steps: [
        {
          number: 1,
          label: "STEP 1: SELECT",
          icon: "map-plus"
        },
        {
          number: 2,
          label: "STEP 2: DEFINE",
          icon: "settings"
        },
        {
          number: 3,
          label: "STEP 3: PARTICIPANTS",
          icon: "account-multiple-plus"
        },
        {
          number: 4,
          label: "STEP 4: REVIEW",
          icon: "flag-checkered"
        }
      ]
    };
  },

  updated() {
    this.$nextTick(function() {
      if (this.activeStep === 2) this.$scrollTo("#challenge-builder");
    });
  },

  methods: {
    activateStep(stepNumber) {
      if (this.isCompletedStep(stepNumber)) {
        /**
         * @type {number}
         */
        this.$emit("activateCompletedStep", stepNumber);
      }
    },

    isCompletedStep(stepNumber) {
      return stepNumber < this.activeStep;
    }
  }
};
</script>

<style lang="sass">
#challenge-builder-steps
  .steps
    margin-bottom: 0 !important
    .step-items
      width: 100% !important
</style>
